var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.id,"type":"hidden","name":_vm.name},domProps:{"value":_vm.chosenVariant ? _vm.chosenVariant : null}})}
var staticRenderFns = []

export { render, staticRenderFns }